const SELECTORS = {
  link: {
    default: "InitialsNavigation-link",
  },
};

class InitialsNavigation {
  /**
   * @param {HTMLElement} container
   * @param {Function} onClick
   */
  constructor(container, onClick) {
    this.container = container;
    this.onClick = onClick;

    this._generateInitialsList();
    this._addEventListener();
  }

  /**
   * Get all initials
   */
  _generateInitialsList() {
    this.initials = this.container.querySelectorAll(
      `.${SELECTORS.link.default}`
    );
  }

  /**
   * Add click eventListener on all intials and call the provided
   * onClick method
   */
  _addEventListener() {
    this.initials.forEach((initial) => {
      initial.addEventListener("click", () => {
        const button = initial.closest(`.${SELECTORS.link.default}`);
        this.onClick(button.dataset.sectionId);
      });
    });
  }

  /**
   * Hide a specific initial by hash
   *
   * @param {string} sectionId
   */
  hideInitial(sectionId) {
    this.initials.forEach((initial) => {
      if (initial.dataset.sectionId === sectionId) {
        const button = initial;
        button.hidden = true;
      }
    });
  }

  /**
   * Show a specific initial by hash
   *
   * @param {string} sectionId
   */
  showInitial(sectionId) {
    this.initials.forEach((initial) => {
      if (initial.dataset.sectionId === sectionId) {
        const button = initial;
        button.hidden = false;
      }
    });
  }
}

export default InitialsNavigation;
